// removed by extract-text-webpack-plugin
module.exports = {"shipment":"_1uM4Hcpyba-dA_BdWotjpo","shipments-list":"_3nG8MtgYuj-6wCaPMRZpFz","shipping-rate-subtext":"_4aE0hfupLbnMhbPnuk5zO"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/DeliveryForm/style.scss
// module id = 874
// module chunks = 0